<template>
    <div class="w-full p-6 bg-white rounded-lg">
        <div>
            <LabelForm>{{ $t("resorts.audiences.key") }} *</LabelForm>
            <vs-input class="w-full border-grey-light" name="key" v-model="audience.key" v-validate="'required'"/>
            <span class="text-sm text-danger">{{ errors.first('key') }}</span>
        </div>

        <LocalizedContent v-model="localizedContent" :fieldsDefinition="[
                { name: 'name', label: $t('resorts.audiences.name'), type: 'text' },
            ]" 
        />

        <div class="mt-10 text-right">
            <button class="inline-block mb-2 mr-2 rounded-lg sk-btn sk-btn-primary"
                @click.stop="handleSave">
                {{ $t("shops.save") }}
            </button>
            <router-link class="inline-block mb-2 mr-2 rounded-lg sk-btn sk-btn-primary btn-border"
                :to="{ name: 'resort-audiences' }">
                {{ $t("shops.cancel") }}
            </router-link>
        </div>
    </div>
</template>

<script>
import LocalizedContent from '@/modules/Shared/Components/form/LocalizedContent'
import LabelForm from '@/modules/Shared/Components/form/LabelForm'
import ElementService from '@/modules/Shared/Pages/sections/ElementService'
import loader from "@/modules/Shared/Mixins/loader";
import DatatableService from '@/modules/Shared/Pages/sections/DatatableService';
import { v4 as uuidv4 } from 'uuid';
import store from "@/modules/Shared/Store/store";

export default {
    name: 'EditAudience',
    mixins: [loader],
    components: {
        LabelForm,
        LocalizedContent,
    },
    data() {
        return {
            audience: {
                uuid: uuidv4(),
                key: '',
                names: {},
                resort_uuid: this.$route.params.uuid,
                order: 0,
            },
            service: new ElementService('v4/resorts/ride-audiences'),
            tableService: new DatatableService('v4/resorts/ride-audiences', { resort_uuid: this.$route.params.uuid }),
        }
    },
    computed: {
        localizedContent: {
            get: function () {
                let languages = []
                Object.entries(this.audience.names).forEach(([key, value]) => {
                    languages.push({
                        'language': key,
                        'name': value
                    })
                })
                return languages
            },
            set: function (newValue) {
                this.audience.names = {};
                newValue.forEach(item => {
                    this.audience.names[item.language] = item.name
                })
            }
        }
    },
    async beforeRouteEnter (to, from, next) {
        if (to.params.elementUuid === undefined) {
            next()
            return
        }
        const service = new ElementService('v4/resorts/ride-audiences')
        const audience = await service.fetchElement(to.params.elementUuid)
        await store.dispatch('setRouteElement', audience)
        next(vm => vm.audience = audience)
    },
    async created() {
        await this.loadAndNotifyError(async () => {
            if (this.isNewAudience()) {
                this.audience.order = await this.getOrder()
            }
        })
    },
    methods: {
        isNewAudience() {
            return this.$route.params.elementUuid === undefined
        },
        payloadForAPI() {
            return {
                ...this.audience,
                ...{ names: this.localizedContent }
            }
        },

        async handleSave() {
            await this.loadAndNotify(async () => {
                if (this.isNewAudience()) {
                    await this.service.createElement(this.audience.uuid, this.payloadForAPI())
                }

                if (!this.isNewAudience()) {
                    await this.service.editElement(this.audience.uuid, this.payloadForAPI())
                }
                this.$router.push({ name: 'resort-audiences' })
            })
        },

        async getOrder() {
            if (!this.isNewAudience()) {
                return this.audience.order
            }

            let audiences = await this.tableService.fetchElements({}, 1, { sort_by: 'order', sort_type: 'desc' })
            if (audiences.data.length > 0) {
                return audiences.data[0].order + 1
            }

            return 0
        },
    }
}
</script>
